module.exports = __webpack_public_path__ + "media/images/change-photo-572a74c4758b9b6e88fd71889ec677ae.png";